import React from 'react';
import ModuleError from 'app/components/districtModulesCommon/ModuleError';
export default function TopNewsError(_ref) {
  let {
    onRetry
  } = _ref;
  return /*#__PURE__*/React.createElement(ModuleError, {
    onClick: onRetry,
    text: "Es ist ein Fehler aufgetreten und die Top-Meldungen konnten leider nicht geladen werden. Bitte versuche es erneut.",
    "data-sentry-element": "ModuleError",
    "data-sentry-component": "TopNewsError",
    "data-sentry-source-file": "TopNewsError.tsx"
  });
}